{
    "name": "digihaven",
    "version": "26.3.14-release",
    "license": "MIT",
    "private": true,
    "scripts": {
        "ng": "ng",
        "nx": "nx",
        "start": "pnpm run exec start",
        "analyze": "pnpm run exec analyze",
        "library-report": "npx ts-node tools/scripts/library-usage-report.ts",
        "preinstall": "npx only-allow pnpm",
        "postinstall": "pnpm run exec postinstall",
        "build": "ng build",
        "build:stats": "pnpm run exec build:stats",
        "test": "nx test --no-tui",
        "test-report": "pnpm run exec test-report",
        "test-all": "npm-run-all -s \"test-once-ci stylehaven-components\" \"test-once-ci digihaven-shared\" \"test-once-ci serieregister\" \"test-once-ci edepot\" \"test-once-ci depot-management\" \"test-once-ci archive-management\"",
        "test-digihaven": "npm-run-all -s \"test-once-ci stylehaven-components\" \"test-once-ci digihaven-shared\" \"test-once-ci serieregister\" \"test-once-ci edepot\" \"test-once-ci depot-management\" \"test-once-ci archive-management\"",
        "e2e": "ng e2e",
        "affected:apps": "nx affected:apps",
        "affected:libs": "nx affected:libs",
        "affected:build": "nx affected:build",
        "affected:e2e": "nx affected:e2e",
        "affected:test": "nx affected:test",
        "affected:lint": "nx affected:lint",
        "affected:dep-graph": "nx affected:dep-graph",
        "affected": "nx affected",
        "lint": "nx workspace-lint && nx lint",
        "format": "nx format:write",
        "format:check": "nx format:check",
        "update": "nx migrate latest",
        "workspace-generator": "nx workspace-generator",
        "dep-graph": "nx dep-graph",
        "help": "nx help",
        "exec": "node exec",
        "test-once-ci": "pnpm run exec test-once-ci",
        "integration-report": "node ./testing/configs/cucumber.report.js",
        "integration": "pnpm run exec integration",
        "integration-without-build": "pnpm run exec integration-without-build",
        "integration-run": "pnpm run exec integration-run",
        "integration-test": "pnpm run exec integration-test",
        "integration-test-no-retry": "pnpm run exec integration-test-no-retry",
        "integration-update": "pnpm run exec integration-update",
        "integration-setup": "pnpm run exec integration-setup",
        "integration-typescript-setup": "pnpm run exec integration-typescript-setup",
        "integration-servers": "pnpm run exec integration-servers",
        "integration-start-frontend": "pnpm run exec integration-start-frontend",
        "integration-start-backend": "pnpm run exec integration-start-backend",
        "integration-start-backend-listener": "pnpm run exec integration-start-backend-listener",
        "install-hooks": "node scripts/hooks/pre-commit.js",
        "set-env": "pnpm run exec set-env",
        "set-integration-env": "pnpm run exec set-integration-env",
        "set-development-env": "pnpm run exec set-development-env",
        "start-offline": "pnpm run exec start-offline",
        "serve-offline": "pnpm run exec serve-offline",
        "start-stylehaven-core": "pnpm --dir ./libs/stylehaven-core --config.verify-deps-before-run=false run start",
        "build-stylehaven-core": "pnpm --dir ./libs/stylehaven-core --config.verify-deps-before-run=false run build",
        "build-stylehaven-core-css": "pnpm --dir ./libs/stylehaven-core --config.verify-deps-before-run=false run build-styles",
        "watch-stylehaven-core": "pnpm --dir ./libs/stylehaven-core --config.verify-deps-before-run=false run watch-assets",
        "workspace-schematic": "nx workspace-schematic",
        "sonar": "sonar-scanner -Dsonar.host.url=$SONAR_HOST_URL -Dsonar.login=$SONAR_LOGIN",
        "check-translations-format": "node check-translations-format",
        "list-most-edited-files": "git log --pretty=format: --name-only | sort | uniq -c | sort -rg | grep '/' | grep -v '.json$' | grep -v 'libs/language/*' | grep -v 'testing/*' | head -30"
    },
    "dependencies": {
        "@angular/animations": "^21.2.5",
        "@angular/cdk": "^21.2.14",
        "@angular/common": "^21.2.15",
        "@angular/core": "^21.2.5",
        "@angular/forms": "^21.2.5",
        "@angular/google-maps": "^21.2.3",
        "@angular/platform-browser": "^21.2.5",
        "@angular/platform-browser-dynamic": "^21.2.5",
        "@angular/router": "^21.2.5",
        "@apollo/client": "^3.8.10",
        "@aws-crypto/sha256-js": "^5.2.0",
        "@duxor/agm-core": "^18.0.0",
        "@googlemaps/markerclusterer": "^2.6.2",
        "@huntsman-cancer-institute/angular-tree-component": "^13.2.1",
        "@mlightcad/cad-simple-viewer": "^1.5.7",
        "@ngrx/entity": "21.1.0",
        "@ngrx/store": "21.1.0",
        "@ngx-file-upload/core": "^21.0.0",
        "@ngx-translate/core": "^15.0.0",
        "@sentry/angular-ivy": "^7.120.4",
        "apollo-angular": "^7.2.1",
        "buffer": "^6.0.3",
        "commons-validator-js": "^1.0.1669",
        "core-js": "^3.49.0",
        "date-fns": "^2.30.0",
        "details-element-polyfill": "^2.4.0",
        "edtf": "4.6.0",
        "element-closest-polyfill": "^1.0.7",
        "fast-equals": "^2.0.4",
        "file-saver": "^2.0.5",
        "filesize": "^10.1.6",
        "formdata-polyfill": "^3.0.20",
        "graphql": "^16.13.2",
        "libphonenumber-js": "^1.12.40",
        "lodash-es": "^4.18.1",
        "mime": "^4.1.0",
        "myna-parser": "^2.5.1",
        "ng-let": "^17.0.4",
        "ngrx-store-localstorage": "^18.0.0",
        "ngx-clipboard": "~15.0.1",
        "ngx-drag-drop": "^18.0.2",
        "ngx-extended-pdf-viewer": "~26.0.4",
        "ngx-image-cropper": "^7.2.1",
        "ngx-infinite-scroll": "^21.0.0",
        "ngx-printer": "^1.9.0",
        "ngx-translate-messageformat-compiler": "^7.2.0",
        "postal-mime": "^1.1.0",
        "replaywebpage": "^2.4.4",
        "rxjs": "^7.8.2",
        "streamsaver": "^2.0.6",
        "tslib": "^2.8.1",
        "video.js": "^7.21.7",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@analogjs/platform": "^2.4.9",
        "@analogjs/vite-plugin-angular": "^2.4.9",
        "@analogjs/vitest-angular": "^2.4.9",
        "@angular-devkit/architect": "^0.2101.5",
        "@angular-devkit/build-angular": "~21.1.5",
        "@angular-devkit/core": "~21.1.5",
        "@angular-devkit/schematics": "~21.1.5",
        "@angular-eslint/eslint-plugin": "^19.8.1",
        "@angular-eslint/eslint-plugin-template": "^19.8.1",
        "@angular-eslint/template-parser": "^19.8.1",
        "@angular/cli": "^21.2.3",
        "@angular/compiler": "^21.2.5",
        "@angular/compiler-cli": "^21.2.5",
        "@angular/language-service": "^21.2.5",
        "@cucumber/cucumber": "^11.3.0",
        "@cucumber/gherkin": "^29.0.0",
        "@cucumber/pretty-formatter": "^1.0.1",
        "@eslint/eslintrc": "^2.1.4",
        "@eslint/js": "~8.57.1",
        "@ngrx/store-devtools": "^21.1.0",
        "@nx/angular": "~22.6.5",
        "@nx/eslint-plugin": "~22.6.5",
        "@nx/js": "~22.6.5",
        "@nx/vite": "^22.0.0",
        "@playwright/test": "^1.59.1",
        "@schematics/angular": "~21.1.5",
        "@swc-node/register": "~1.11.1",
        "@swc/core": "~1.15.8",
        "@swc/helpers": "~0.5.19",
        "@types/file-saver": "^2.0.7",
        "@types/google.analytics": "0.0.46",
        "@types/google.maps": "^3.65.2",
        "@types/jasmine": "4.6.6",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "22.12.0",
        "@types/streamsaver": "^2.0.5",
        "@types/video.js": "^7.3.58",
        "@typescript-eslint/eslint-plugin": "^8.57.1",
        "@typescript-eslint/parser": "^8.57.1",
        "@vitest/coverage-v8": "^3.0.0",
        "@vitest/ui": "^4.1.4",
        "cross-env": "~7.0.3",
        "cucumber-html-reporter": "^6.0.0",
        "eslint": "^9.39.4",
        "eslint-config-prettier": "^10.1.8",
        "express": "^4.22.1",
        "fast-xml-parser": "^5.5.7",
        "globals": "^17.4.0",
        "http-proxy-middleware": "^2.0.9",
        "jsdom": "^29.0.2",
        "mkdirp": "^1.0.4",
        "morgan": "^1.10.1",
        "multer": "^2.1.1",
        "ng-mocks": "^14.15.2",
        "nodemon": "^3.1.14",
        "npm-run-all2": "^5.0.2",
        "nx": "~22.2.7",
        "patch-package": "^8.0.1",
        "playwright": "^1.59.1",
        "playwright-expect": "^0.1.2",
        "prettier": "^3.8.1",
        "run": "^1.5.0",
        "sass": "^1.98.0",
        "seedrandom": "^3.0.5",
        "sonar-scanner": "^3.1.0",
        "ts-morph": "^27.0.2",
        "ts-node": "^10.9.2",
        "typescript": "~5.9.3",
        "typescript-eslint": "^8.57.1",
        "vite": "^7.0.0",
        "vite-tsconfig-paths": "^6.1.1",
        "vitest": "^4.1.4",
        "webpack": "^5.105.4",
        "webpack-bundle-analyzer": "^4.10.2",
        "yargs": "^16.2.0"
    }
}
